import SoftBox from "src/components/SoftBox";
import IconButton from "@mui/material/IconButton";
import { Icon } from "@mui/material";
import LocationAddress from "./components/LocationAddress";

const iconButtonStyles = ({ typography: { size }, breakpoints }) => ({
  px: 0.9,

  "& .material-icons, .material-icons-round": {
    fontSize: `${size.md} !important`,
  },

  "& .MuiTypography-root": {
    display: "none",

    [breakpoints.up("sm")]: {
      display: "inline-block",
      lineHeight: 1.2,
      ml: 0.5,
    },
  },
});

export const TableActions = {
  EDIT: "EDIT",
  DELETE: "DELETE",
  TOGGLE: "TOGGLE",
};

export const getTableColumns = (onAction) => [
  {
    Header: "ICAO",
    accessor: "icao",
    width: "10%",
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Address",
    Cell: ({ row: { original } }) => {
      const { address } = original;
      if (!address) return null;
      return <LocationAddress address={address} />;
    },
  },
  {
    Header: "Number",
    accessor: "number",
    width: "12%",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Actions",
    width: "10%",
    Cell: ({ row: { original } }) => (
      <SoftBox sx={{ display: "flex" }}>
        <IconButton
          aria-label="delete"
          sx={iconButtonStyles}
          onClick={() => onAction(TableActions.DELETE, original)}
        >
          <Icon>delete</Icon>
        </IconButton>
        <IconButton
          aria-label="edit"
          sx={iconButtonStyles}
          onClick={() => onAction(TableActions.EDIT, original)}
        >
          <Icon>edit</Icon>
        </IconButton>
      </SoftBox>
    ),
  },
];
